import Button from 'components/Common/Button'
import { TimeSlotsPanel } from './style'
import React from 'react'

const SlotsSelector = ({ onClick, availableSlots }) => {
  return (
    <TimeSlotsPanel>
      {availableSlots.map((slot, index) => {
        const { slotStartTime } = slot
        const startTime = slotStartTime
        const label = `${startTime}`
        return (
          <Button
            key={index}
            label={label}
            className="rounded-none my-3 w-full"
            variant="secondary"
            type="button"
            onClick={() => onClick(slot)}
          />
        )
      })}
    </TimeSlotsPanel>
  )
}

export default SlotsSelector
